var a="all";export{a as ALL};
//# sourceMappingURL=constants.mjs.map
